var $0d092e8092be4ecc$exports = {};
$0d092e8092be4ecc$exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "loadingMore": `Se \xeencarc\u{103} mai multe...`
};


export {$0d092e8092be4ecc$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
